import { TIMESHEETDETAILS_SUCCESS, TIMESHEETDETAILS_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const timeSheetDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case TIMESHEETDETAILS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case TIMESHEETDETAILS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default timeSheetDetailsReducer;
